import { ky } from '@/shared/ky/ky-with-auth'

export type WorkspaceConnectorStatusResponse = {
  connectorId: string | null
  status: string | null
  online: boolean
  version: string | null
  lastSeenAt: string | null
}

export async function fetchWorkspaceConnectorStatus(
  workspaceId: string,
): Promise<WorkspaceConnectorStatusResponse> {
  return ky
    .get(`workspaces/${workspaceId}/connector`)
    .json<WorkspaceConnectorStatusResponse>()
}
